import { Injectable, OnDestroy } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DynamicDialogRef, DialogService, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { AuthorizationService } from '../authorization/authorization.service';
import { KeyValueModel } from '@core/key-value-model';
import { DiagrammeNoteComponent } from '@shared/components/diagramme-note/diagramme-note.component';
import { LangueModel } from '@core/models/langue.model';
import { EnumStatusPublish } from '@shared/tools/enums/enum-status.enum';

@Injectable({
  providedIn: 'root'
})
export class CommonService implements OnDestroy {

  public langues: LangueModel[]=[];

  constructor(
    public confirmationService: ConfirmationService,
    public dynamicDialogRef: DynamicDialogRef,
    public dialogService: DialogService,
    public messageService: MessageService,
    public authorizationService: AuthorizationService,
  ) {
    this.dynamicDialogRef.onClose.subscribe((result: any) => {
      console.log('Le dialogue a été fermé avec la donnée suivante :', result);
    });
  }

  ngOnDestroy(): void {
      this.dynamicDialogRef?.close();
  }

  showPopUpFile(keyValue: KeyValueModel){
    if (keyValue.pathUrl!=='') {
      let data = {
        keyValue: keyValue,
      };
      const ref = this.dialogService.open(DiagrammeNoteComponent, {
          header: keyValue.title,
          contentStyle: {"overflow":"auto"},
          //baseZIndex: 10000,
          width: '100%',
          height: '100%',
          data: data
      });

      ref.onClose.subscribe(( result ) => {
          if (result) {
            if( result.isReloadPage ){
              //this.loadData();
            }
          }
      });
    }
  }
  extractVideoId(url: string): string | null {
    const regex = /[?&]v=([^&]+)/;
    const match = url.match(regex);
    return match ? match[1] : null;
  }

  fetch(linkData:string, cb: (i: any[]) => void) {
    const req = new XMLHttpRequest();
    req.open('GET', linkData);
    req.onload = () => {
      const data = JSON.parse(req.response);
      cb(data);
    };
    req.send();
  }

  onPlayerReady(event: any) {
    console.log('Player is ready', event);
  }

  onStateChange(event: any) {
    console.log('Player state changed', event);
  }

  onError(event: any) {
    console.log('Player encountered an error', event);
  }

  check(data: boolean){
    return data?'fas fa-check-circle':'far fa-times-circle';
  }
  badgeCS(data: boolean){
    return data?'badge bg-green cp f9':'badge bg-red cp f9';
  }
  iconStatus(data: number){
    switch (data) {
      case EnumStatusPublish.Public:
        return 'fa fa-globe';
      case EnumStatusPublish.Private:
        return 'fa fa-lock';
      default:
        return 'fa fa-lock';
    }
  }
  labelStatus(data: number){
    switch (data) {
      case EnumStatusPublish.Public:
        return 'VISIBLE_TO_ANYONE';
      case EnumStatusPublish.Private:
        return 'VISIBLE_TO_ONLY_ME';
      default:
        return 'VISIBLE_TO_ONLY_ME';
    }
  }
  badgeStatus(data: number){
    switch (data) {
      case EnumStatusPublish.Public:
        return 'badge bg-green cp';
      case EnumStatusPublish.Private:
        return 'badge bg-orange cp ';
      case EnumStatusPublish.Suspend:
        return 'badge bg-red cp ';
      default:
        return 'badge bg-orange cp';
    }
  }
  cleanText(input: string, format: string='\n'): string {
    return input
        .replace(/<br\s*\/?>/gi, format)  // Remplace <br /> et variantes par un saut de ligne
        .replace(/(\r\r|\r\n\r\n|\n\n)+/g, format)  // Supprime les retours multiples
        .trim(); // Supprime les espaces inutiles au début et à la fin
  }
  cleanTextAddBr(input: string): string {
    return input
        .replace(/<br\s*\/?>/gi, '\n')  // Remplace <br /> et variantes par un saut de ligne
        .replace(/(\r\r|\r\n\r\n|\n\n)+/g, '\n')  // Supprime les retours multiples
        .trim(); // Supprime les espaces inutiles au début et à la fin
  }
  isUrl(str: string): boolean {
    try {
      new URL(str); // Si l'URL est valide, l'objet URL sera créé.
      return true;  // Cela signifie que c'est une URL valide.
    } catch (e) {
      return false;   // Cela signifie que ce n'est pas une URL valide.
    }
  }
  _isBase64(str: string): boolean {
    const base64Regex = /^(?:[A-Za-z0-9+\/]{4})*(?:[A-Za-z0-9+\/]{2}==|[A-Za-z0-9+\/]{3}=)?$/;
    return base64Regex.test(str);
  }
  isBase64(str: string): boolean {
    const base64Regex = /^(?:[A-Za-z0-9+\/]{4})*(?:[A-Za-z0-9+\/]{2}==|[A-Za-z0-9+\/]{3}=)?$/;
    return base64Regex.test(str) ;//&& str.length % 4 === 0; // Ajout d'une vérification de longueur multiple de 4
}
  base64ToBlob(base64: string, mimeType: string): Blob {
    const byteCharacters = atob(base64); // Décoder la chaîne base64 en bytes
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
        const slice = byteCharacters.slice(offset, offset + 1024);
        const byteNumbers = new Array(slice.length);

        for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }

        byteArrays.push(new Uint8Array(byteNumbers));
    }

    return new Blob(byteArrays, { type: mimeType });
}
}
